import { userHasConsentedToStatistics } from '@/features/gdpr/utils/permissions';

import { appId } from './app-id';

export const trackIntercomEvent = (event: string, data?: object) => {
  if (!appId || !userHasConsentedToStatistics()) return;
  window.Intercom?.('trackEvent', event, data);
};
